import { RenderBlockProps } from '@orgnc/core/components/blocks/Blocks/helpers/RenderBlock';
import { BlockFragment } from '@orgnc/core/lib/wordpress/api/fragments/blocksFragment';
import Script from 'next/script';
import React from 'react';

interface STNVideoPlayerProps {
  block: {
    attributes: {
      data: {
        embed_url: string;
      };
    };
  };
}

const TockifyEmbedBlock: React.FunctionComponent<RenderBlockProps> = ({
  block: props,
}) => {
  const block = props as unknown as BlockFragment<STNVideoPlayerProps>;
  const { embed_url: embedUrl } = block.attributes.data;

  return (
    <>
      <div
        data-tockify-component="mini"
        data-tockify-calendar="thelandis"
      ></div>
      <Script
        strategy="afterInteractive"
        data-cfasync="false"
        data-tockify-script="embed"
        src={embedUrl}
      ></Script>
    </>
  );
};

export default TockifyEmbedBlock;
